module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._c('md-tabs', {
    attrs: {
      "md-fixed": ""
    }
  }, [_vm._c('md-tab', {
    attrs: {
      "md-label": "My giftbox"
    }
  }, _vm._l((_vm.giftbox), function(gift) {
    return _vm._c('md-card', [_vm._c('md-card-header', [_vm._c('h2', {
      staticClass: "md-title"
    }, [_vm._v("\n            " + _vm._s(gift.name) + "\n          ")]), _vm._v(" "), _vm._c('div', {
      staticClass: "md-subhead"
    }, [_vm._v("\n            $ " + _vm._s(gift.currentAmount) + " / $ " + _vm._s(gift.totalPrice) + "\n          ")])]), _vm._v(" "), _vm._c('md-card-content', [_vm._c('div', [_vm._v(_vm._s(gift.note))]), _vm._v(" "), _vm._c('div', [_vm._v("Need Rating: " + _vm._s(gift.need))]), _vm._v(" "), _vm._c('div', [_vm._v("Added on: "), _vm._c('time', {
      attrs: {
        "datetime": _vm.formatDate(gift.timestamp)
      }
    }, [_vm._v(_vm._s(_vm.formatDate(gift.timestamp)))])]), _vm._v(" "), _vm._c('div', [_vm._v("Funded: " + _vm._s(_vm.calculatePercentFunded(gift.currentAmount, gift.totalPrice)) + "%")]), _vm._v(" "), _vm._c('md-progress', {
      attrs: {
        "md-progress": _vm.calculatePercentFunded(gift.currentAmount, gift.totalPrice)
      }
    })], 1), _vm._v(" "), _vm._c('md-card-actions', [_vm._c('md-button', {
      staticClass: "md-raised md-primary",
      on: {
        "click": function($event) {
          _vm.receivedGift(gift)
        }
      }
    }, [_vm._c('md-icon', [_vm._v("check")]), _vm._v(" "), _vm._c('md-tooltip', {
      attrs: {
        "md-delay": "500",
        "md-direction": "bottom"
      }
    }, [_vm._v("Bought / Received")])], 1), _vm._v(" "), _vm._c('md-button', {
      staticClass: "md-raised md-warn",
      on: {
        "click": function($event) {
          _vm.removeGift(gift)
        }
      }
    }, [_vm._c('md-icon', [_vm._v("delete")]), _vm._v(" "), _vm._c('md-tooltip', {
      attrs: {
        "md-delay": "500",
        "md-direction": "bottom"
      }
    }, [_vm._v("Remove / Delete")])], 1)], 1)], 1)
  })), _vm._v(" "), _vm._c('md-tab', {
    attrs: {
      "md-label": "Friend gifts"
    }
  }, [_vm._c('p', [_vm._v("Tab for friend gifts.")])]), _vm._v(" "), _vm._c('md-tab', {
    attrs: {
      "md-label": "Gift history"
    }
  }, _vm._l((_vm.gifthistory), function(gift) {
    return _vm._c('md-card', [_vm._c('md-card-header', [_vm._c('h2', {
      staticClass: "md-title"
    }, [_vm._v("\n            " + _vm._s(gift.name) + "\n          ")]), _vm._v(" "), _vm._c('div', {
      staticClass: "md-subhead"
    }, [_vm._v("\n            $ " + _vm._s(gift.currentAmount) + " / $ " + _vm._s(gift.totalPrice) + "\n          ")])]), _vm._v(" "), _vm._c('md-card-content', [_vm._c('md-progress', {
      attrs: {
        "md-progress": _vm.calculatePercentFunded(gift.currentAmount, gift.totalPrice)
      }
    })], 1), _vm._v(" "), _vm._c('md-card-actions', [_vm._c('md-button', {
      staticClass: "md-raised md-warn",
      on: {
        "click": function($event) {
          _vm.removeGiftFromHistory(gift)
        }
      }
    }, [_vm._c('md-icon', [_vm._v("delete")]), _vm._v(" "), _vm._c('md-tooltip', {
      attrs: {
        "md-delay": "500",
        "md-direction": "bottom"
      }
    }, [_vm._v("Remove / Delete")])], 1)], 1)], 1)
  })), _vm._v(" "), _vm._c('md-tab', {
    attrs: {
      "md-label": "Add gift"
    }
  }, [_vm._c('md-card', [_vm._c('md-card-content', [_vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("wallet_giftcard")]), _vm._v(" "), _vm._c('label', [_vm._v("Name:")]), _vm._v(" "), _vm._c('md-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGift.name),
      expression: "newGift.name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newGift.name)
    },
    on: {
      "input": function($event) {
        _vm.newGift.name = $event
      }
    }
  })], 1), _vm._v(" "), _vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("speaker_notes")]), _vm._v(" "), _vm._c('label', [_vm._v("Note:")]), _vm._v(" "), _vm._c('md-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGift.note),
      expression: "newGift.note"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newGift.note)
    },
    on: {
      "input": function($event) {
        _vm.newGift.note = $event
      }
    }
  })], 1), _vm._v(" "), _vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("star_half")]), _vm._v(" "), _vm._c('label', [_vm._v("Need (1/3):")]), _vm._v(" "), _vm._c('md-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGift.need),
      expression: "newGift.need"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newGift.need)
    },
    on: {
      "input": function($event) {
        _vm.newGift.need = $event
      }
    }
  })], 1), _vm._v(" "), _vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("image")]), _vm._v(" "), _vm._c('label', [_vm._v("Picture:")]), _vm._v(" "), _vm._c('md-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGift.picture),
      expression: "newGift.picture"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newGift.picture)
    },
    on: {
      "input": function($event) {
        _vm.newGift.picture = $event
      }
    }
  })], 1), _vm._v(" "), _vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("link")]), _vm._v(" "), _vm._c('label', [_vm._v("URL:")]), _vm._v(" "), _vm._c('md-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGift.url),
      expression: "newGift.url"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newGift.url)
    },
    on: {
      "input": function($event) {
        _vm.newGift.url = $event
      }
    }
  })], 1), _vm._v(" "), _vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("attach_money")]), _vm._v(" "), _vm._c('label', [_vm._v("Current amount:")]), _vm._v(" "), _vm._c('md-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGift.currentAmount),
      expression: "newGift.currentAmount"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newGift.currentAmount)
    },
    on: {
      "input": function($event) {
        _vm.newGift.currentAmount = $event
      }
    }
  })], 1), _vm._v(" "), _vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("attach_money")]), _vm._v(" "), _vm._c('label', [_vm._v("Total price:")]), _vm._v(" "), _vm._c('md-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newGift.totalPrice),
      expression: "newGift.totalPrice"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.newGift.totalPrice)
    },
    on: {
      "input": function($event) {
        _vm.newGift.totalPrice = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _vm._c('md-card-actions', [_vm._c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        _vm.addGift()
      }
    }
  }, [_vm._v("Add")])], 1)], 1)], 1), _vm._v(" "), _vm._c('md-tab', {
    attrs: {
      "md-label": "Settings"
    }
  }, [_vm._c('md-card', [_vm._c('md-card-content', [_vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("speaker_notes")]), _vm._v(" "), _vm._c('label', [_vm._v("Email:")]), _vm._v(" "), _vm._c('md-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.loginEmail),
      expression: "settings.loginEmail"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.settings.loginEmail)
    },
    on: {
      "input": function($event) {
        _vm.settings.loginEmail = $event
      }
    }
  })], 1), _vm._v(" "), _vm._c('md-input-container', [_vm._c('md-icon', [_vm._v("speaker_notes")]), _vm._v(" "), _vm._c('label', [_vm._v("Password:")]), _vm._v(" "), _vm._c('md-input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.loginPassword),
      expression: "settings.loginPassword"
    }],
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.settings.loginPassword)
    },
    on: {
      "input": function($event) {
        _vm.settings.loginPassword = $event
      }
    }
  })], 1)], 1), _vm._v(" "), _vm._c('md-card-actions', [_vm._c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.loginUser
    }
  }, [_vm._v("Login")]), _vm._v(" "), _vm._c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.logoutUser
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _vm._c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": _vm.isUserLoggedIn
    }
  }, [_vm._v("isUserLoggedIn?")])], 1)], 1)], 1)], 1), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('footer', {
    staticClass: "py-3"
  }, [_vm._c('div', {
    staticClass: "container text-center"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col"
  }, [_vm._c('div', [_vm._v("Copyright © 2013-2017 Georgi Yanev & Sofia Lindberg")]), _vm._v(" "), _vm._c('div', [_vm._c('i', {
    staticClass: "fa fa-code",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" with "), _vm._c('i', {
    staticClass: "fa fa-heart",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" for little Anton.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46cf7b8e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 124
// module chunks = 2